module.exports = __webpack_public_path__ + "img/744.3f28c373.jpg";